import { DateTime } from 'luxon';

import { getNthBusinessDay } from './getNthBusinessDay';

/**
 * Returns the current reporting cycle and also the prior month reporting cycle if we're close to (5 business days away from) the last reporting cycle
 */

export const getCurrentAndMaybePriorReportingCycles = (targetDate = new Date()) => {
  const firstOfCurrentMonth = DateTime.fromJSDate(targetDate).startOf('month');
  const currentDateTime = DateTime.fromJSDate(targetDate);
  const currentMonthYear = { month: currentDateTime.month, year: currentDateTime.year };
  const priorDateTime = firstOfCurrentMonth.minus({ months: 1 });
  const priorMonthYear = { month: priorDateTime.month, year: priorDateTime.year };

  const tenthBusinessDayOfMonth = getNthBusinessDay({
    startDate: firstOfCurrentMonth,
    direction: 'forward',
    excludedDays: [],
    includeStartDate: true,
    n: 10,
  });

  const todayDateTime = DateTime.fromJSDate(targetDate).startOf('day');
  if (tenthBusinessDayOfMonth >= todayDateTime) {
    return [priorMonthYear, currentMonthYear];
  }

  return [currentMonthYear];
};
